import { render, staticRenderFns } from "./FixedDeposit.vue?vue&type=template&id=b150206a&"
import script from "./FixedDeposit.vue?vue&type=script&lang=js&"
export * from "./FixedDeposit.vue?vue&type=script&lang=js&"
import style0 from "./FixedDeposit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports